export enum TabID {
	GroupInformation = 'GroupInformation',
	Students = 'Students',
}
